<script>
  import { fade } from 'svelte/transition';
  export let text;
</script>

{#each [text] as text (text)}
<span in:fade="{{ duration: 300 }}">{ @html text }</span>
{/each}